<template>
  <ui-dialog
    :title="$t('message.permissions.facilitiesPermissionsTitle')"
    :show="show"
    @input="closeDialog"
    custom-class="facilities-dialog"
  >
    <template #header>
      <div class="d-flex flex-row align-center justify-space-between">
        <h3 v-if="editMode">
          {{ $t("message.permissions.editFacilitiesPermissionsTitle") }}
        </h3>
        <h3 v-else-if="previewMode">
          {{ $t("message.permissions.previewFacilitiesPermissionsTitle") }}
        </h3>
        <h3 v-else>
          {{ $t("message.permissions.facilitiesPermissionsTitle") }}
        </h3>
        <v-btn
          icon
          @click="showEditFacilities"
          v-if="previewMode && accountType !== accountTypes.OWNER"
        >
          <v-icon size="24">icon-edit</v-icon>
        </v-btn>
      </div>
    </template>

    <div class="facilities-dialog-body">
      <PreviewData show-type show-email divider />
      <FacilitiesList :show-error="noFacilitiesSelected" />
    </div>

    <template #actions>
      <template v-if="previewMode">
        <ui-button @click="showPermissionsDialog">
          {{ $t("message.permissions.backToPermissions") }}
        </ui-button>
      </template>
      <template v-else-if="editMode">
        <ui-button @click="showPermissionsDialog">
          {{ $t("message.permissions.backToPermissions") }}
        </ui-button>
        <ui-button color="primary" @click="showCompleteDialog">
          {{ $t("message.common.save") }}
        </ui-button>
      </template>
      <template v-else>
        <ui-button @click="showMemberDialog">
          {{ $t("message.common.back") }}
        </ui-button>
        <ui-button color="primary" @click="showPermissionsDialog">
          {{ $t("message.common.next") }}
        </ui-button>
      </template>
    </template>
  </ui-dialog>
</template>

<script>
import { companyMember } from "@/helpers/mixins/company-member";
import { PermissionsActiveDialog } from "@/enums/permissions-active-dialog";
import FacilitiesList from "@/components/Permissions/FacilitiesList";
import { pluralCount } from "@/helpers/helpers";
import PreviewData from "@/components/Permissions/PreviewData";

export default {
  name: "FacilitiesDialog",
  mixins: [companyMember],
  components: {
    FacilitiesList,
    PreviewData
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasFacilitySelected() {
      return (
        !!this.$store.getters["facilities/selectedFacilitiesCount"] ||
        !!this.$store.getters["facilitiesGroups/selectedGroupsCount"] ||
        this.$store.state.permissions.member.allFacilitiesAccess
      );
    }
  },
  data() {
    return {
      noFacilitiesSelected: false
    };
  },
  methods: {
    getFacilitiesNumberLabel(count) {
      return pluralCount("message.pluralForms.facility", count);
    },

    showMemberDialog() {
      this.setActiveDialog(PermissionsActiveDialog.MEMBERS);
    },

    showCompleteDialog() {
      if (this.isValid()) {
        this.setActiveDialog(PermissionsActiveDialog.COMPLETE);
      }
    },

    showPermissionsDialog() {
      if (this.isValid()) {
        this.setActiveDialog(PermissionsActiveDialog.PERMISSIONS, this.mode);
      }
    },

    showEditFacilities() {
      this.setActiveDialog(PermissionsActiveDialog.FACILITIES, "edit");
    },

    isValid() {
      this.noFacilitiesSelected =
        !this.hasFacilitySelected || this.allFacilitiesAccess;

      return !this.noFacilitiesSelected;
    }
  }
};
</script>
